import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';
import Meta from '../shared/Meta';
import styles from '../../../stylesheets/public/layouts/ErrorPage.module.postcss';

function Error500Page() {
  const { vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <div className={styles.ErrorPage}>
      <Meta noindex title='Something Went Wrong' />

      <div className={styles.ErrorPage_hero}>
        <p className={styles.ErrorPage_code}>500</p>
        <h1 className={styles.ErrorPage_heading}>
          Something went wrong on our end.
        </h1>
        <p className={styles.ErrorPage_subtitle}>
          Our kitchen is having a moment. We&apos;re aware of the issue and working to fix it.
          In the meantime, try refreshing the page or come back shortly.
        </p>
      </div>

      <div className={styles.ErrorPage_actions}>
        <Link className='Button Button--large' to='/'>
          Back to Home
        </Link>
        <Link className='Button Button--large Button--outlined' to='/search'>
          Find Food {vehicle_type}s
        </Link>
      </div>

      <div className={styles.ErrorPage_suggestions}>
        <h2 className={styles.ErrorPage_suggestionsTitle}>While you wait, you can try...</h2>
        <div className={styles.ErrorPage_grid}>
          <Link to='/search' className={styles.ErrorPage_card}>
            <strong>Find food {vehicleType}s near you</strong>
            <span>Browse today&apos;s schedule and locations</span>
          </Link>
          <Link to='/catering' className={styles.ErrorPage_card}>
            <strong>Book catering for an event</strong>
            <span>Get free quotes from local {vehicleType}s</span>
          </Link>
          <Link to='/services' className={styles.ErrorPage_card}>
            <strong>Food {vehicleType}s at your property</strong>
            <span>Office parks, apartments, and breweries</span>
          </Link>
          <Link to='/support' className={styles.ErrorPage_card}>
            <strong>Contact support</strong>
            <span>We&apos;re here to help</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Error500Page;
